import { Header, Spinner } from 'view/components';
import { useEffect, useState } from 'react';
import { CandidateListItem, NoResultsBlock } from 'view/pages/candidates/components';
import * as CS from 'view/pages/candidates/commonStyled';
import { useNavigate } from 'react-router';
import {
  APPLICANTS_PER_PAGE,
  useGetApplicants,
} from 'view/pages/candidates/hooks/useGetApplicants';
import { AppliedStatusPurpleIcon, InvitedStatusPurpleIcon } from 'assets';
import * as S from './styled';

const Applicants = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [appliedPage, setAppliedPage] = useState(1);
  const [invitedPage, setInvitedPage] = useState(1);

  const params = new URLSearchParams(window.location.search);
  const applicantType = params.get('applicantType');
  const jobPostId: any = params.get('jobPostId');

  const {
    isLoading: isAllApplicantsLoading,
    getAllApplicants,
    data: allApplicantsData,
  } = useGetApplicants();

  const {
    isLoading: isAppliedApplicantsLoading,
    getAppliedApplicants,
    data: appliedApplicantsData,
  } = useGetApplicants();

  const {
    isLoading: isInvitedApplicantsLoading,
    getInvitedApplicants,
    data: invitedApplicantsData,
  } = useGetApplicants();

  useEffect(() => {
    getAllApplicants(jobPostId);
    getAppliedApplicants(jobPostId);
    getInvitedApplicants(jobPostId);
  }, []);

  const updateUrl = (applicantType: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set('applicantType', applicantType);
    navigate({
      pathname: window.location.pathname,
      search: `?${params.toString()}`,
    });
  };

  return (
    <S.Wrapper>
      <Header />
      <S.TabsContainer>
        <S.TabItem
          selected={applicantType === 'all'}
          onClick={() => {
            updateUrl('all');
          }}
          style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
        >
          <p>All ({allApplicantsData?.total || 0})</p>
        </S.TabItem>
        <S.TabItem
          selected={applicantType === 'applied'}
          onClick={() => {
            updateUrl('applied');
          }}
          style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
        >
          <AppliedStatusPurpleIcon selected={applicantType === 'applied'} />
          <p>Applied ({appliedApplicantsData?.total || 0})</p>
        </S.TabItem>
        <S.TabItem
          selected={applicantType === 'invited'}
          onClick={() => {
            updateUrl('invited');
          }}
          style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
        >
          <InvitedStatusPurpleIcon selected={applicantType === 'invited'} />
          <p>Invited ({invitedApplicantsData?.total || 0})</p>
        </S.TabItem>
      </S.TabsContainer>
      {applicantType === 'all' && (
        <S.MainContentWrapper>
          {isAllApplicantsLoading && (
            <Spinner
              variant="outlined"
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                backgroundColor: 'rgba(217, 225, 255, 0.3)',
                width: '100%',
                height: '100%',
                zIndex: 10,
              }}
            />
          )}
          {!isAllApplicantsLoading && !allApplicantsData?.total && (
            <NoResultsBlock title="🕵️‍♂️ No Applicants Found Here" subTitle="" />
          )}
          {allApplicantsData?.total && !!allApplicantsData?.results?.length ? (
            <>
              <S.CandidatesListBlockMainWrapper>
                <S.ApplicantsListBlockTitle>
                  {allApplicantsData?.total} applicants
                </S.ApplicantsListBlockTitle>
                {allApplicantsData?.results?.map((item) => {
                  return (
                    <CandidateListItem
                      candidate={item}
                      key={item.id}
                      successFunction={() => {
                        getAllApplicants(jobPostId, page); // adding to favorite
                        getAppliedApplicants(jobPostId, appliedPage);
                        getInvitedApplicants(jobPostId, invitedPage);
                      }}
                      withStatus
                      jobPostId={jobPostId}
                    />
                  );
                })}
              </S.CandidatesListBlockMainWrapper>
              <CS.CustomPagination
                count={Math.ceil(allApplicantsData.total / APPLICANTS_PER_PAGE)}
                shape="rounded"
                page={page}
                onChange={(e, page) => {
                  setPage(page);
                  getAllApplicants(page);
                }}
                style={{ margin: 'auto 0 0 auto' }}
              />
            </>
          ) : null}
        </S.MainContentWrapper>
      )}
      {applicantType === 'applied' && (
        <S.MainContentWrapper>
          {isAppliedApplicantsLoading && (
            <Spinner
              variant="outlined"
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                backgroundColor: 'rgba(217, 225, 255, 0.3)',
                width: '100%',
                height: '100%',
                zIndex: 10,
              }}
            />
          )}
          {!isAppliedApplicantsLoading && !appliedApplicantsData?.total && (
            <NoResultsBlock title="🕵️‍♂️ No Applicants Found Here" subTitle="" />
          )}
          {appliedApplicantsData?.total && !!appliedApplicantsData?.results?.length ? (
            <>
              <S.CandidatesListBlockMainWrapper>
                <S.ApplicantsListBlockTitle>
                  {appliedApplicantsData?.total} applicants
                </S.ApplicantsListBlockTitle>
                {appliedApplicantsData?.results?.map((item) => {
                  return (
                    <CandidateListItem
                      candidate={item}
                      key={item.id}
                      successFunction={() => {
                        getAppliedApplicants(jobPostId, appliedPage); // adding to favorite
                        getAllApplicants(jobPostId, page);
                      }}
                      withStatus
                      jobPostId={jobPostId}
                    />
                  );
                })}
              </S.CandidatesListBlockMainWrapper>
              <CS.CustomPagination
                count={Math.ceil(appliedApplicantsData.total / APPLICANTS_PER_PAGE)}
                shape="rounded"
                page={appliedPage}
                onChange={(e, page) => {
                  setAppliedPage(page);
                  getAppliedApplicants(page);
                }}
                style={{ margin: 'auto 0 0 auto' }}
              />
            </>
          ) : null}
        </S.MainContentWrapper>
      )}
      {applicantType === 'invited' && (
        <S.MainContentWrapper>
          {isInvitedApplicantsLoading && (
            <Spinner
              variant="outlined"
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                backgroundColor: 'rgba(217, 225, 255, 0.3)',
                width: '100%',
                height: '100%',
                zIndex: 10,
              }}
            />
          )}
          {!isInvitedApplicantsLoading && !invitedApplicantsData?.total && (
            <NoResultsBlock title="🕵️‍♂️ No Applicants Found Here" subTitle="" />
          )}
          {invitedApplicantsData?.total && !!invitedApplicantsData?.results?.length ? (
            <>
              <S.CandidatesListBlockMainWrapper>
                <S.ApplicantsListBlockTitle>
                  {invitedApplicantsData?.total} applicants
                </S.ApplicantsListBlockTitle>
                {invitedApplicantsData?.results?.map((item) => {
                  return (
                    <CandidateListItem
                      candidate={item}
                      key={item.id}
                      successFunction={() => {
                        getInvitedApplicants(jobPostId, invitedPage); // adding to favorite
                        getAllApplicants(jobPostId, page);
                      }}
                      withStatus
                      jobPostId={jobPostId}
                    />
                  );
                })}
              </S.CandidatesListBlockMainWrapper>
              <CS.CustomPagination
                count={Math.ceil(invitedApplicantsData.total / APPLICANTS_PER_PAGE)}
                shape="rounded"
                page={invitedPage}
                onChange={(e, page) => {
                  setInvitedPage(page);
                  getInvitedApplicants(page);
                }}
                style={{ margin: 'auto 0 0 auto' }}
              />
            </>
          ) : null}
        </S.MainContentWrapper>
      )}
    </S.Wrapper>
  );
};

export default Applicants;
